import { toast, type Id } from "react-toastify";

// Store the current active toast ID
let activeToastId: Id | null = null;

const useToast = (message: string, type: "error" | "warning" | "success" | "info" = "success") => {
  // If there's already an active toast, don't show a new one
  if (activeToastId !== null && toast.isActive(activeToastId)) {
    return;
  }

  // Theme colors
  const isRtl = localStorage.getItem("i18nextLng") === "ar";
  const position = isRtl ? "bottom-left" : "bottom-right";
  const toastStyles = {
    success: "bg-[#E7FF9E]! text-black-500!",
    error: "bg-[#ED8C8D]! text-black-500!",
    warning: "bg-[#FFB782]! text-black-500!",
    info: "bg-[#A1D8F7]! text-black-500!",
  };

  // Show the toast and store its ID
  activeToastId = toast[type](message, {
    position: position,
    autoClose: 2000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    className: `${toastStyles[type]} !font-medium !rounded-lg !shadow-lg !p-5 `,
    rtl: isRtl,
    onClose: () => {
      // Clear the active toast ID when the toast is closed
      activeToastId = null;
    },
  });
};

export default useToast;
